var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.isLoading)?_c('div',{staticClass:"loading-container"},[_c('img',{staticClass:"loading-logo",attrs:{"src":require('@/assets/10.png'),"alt":"Logo"}})]):_c('div',{staticClass:"home"},[_c('HeroSection'),_c('OrdersSection'),_c('ourRequests'),_c('OurEmployees'),_c('LocationMap')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }